import React from "react";
import styled from "styled-components";
import Popup from "./Popup";
import { useTranslation } from 'react-i18next';
import Input from "./Input";
import H2 from "./H2";
import BlueButton from "./BlueButton";

const Container = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ccc;
    cursor: pointer;

    .croix_bleue {
        width: 20px;
        margin: 20px 10px;
    }

    > div {
        span {
            font-weight: 600;
            color: blue;
        }

        img {
            display: inline-block;
            width: 25px;
            margin: 10px 12px;

            &:first-child {
                margin-left: 0;
                width: 30px;
            }
        }
    }
`;

const SocialNetworks = (props) => {

    const [twitter, setTwitter] = React.useState(props.twitter || '');
    const [instagram, setInstagram] = React.useState(props.instagram || '');
    const [linkedin, setLinkedin] = React.useState(props.linkedin || '');
    const [popupOpen, setPopupOpen] = React.useState(false);
    const { i18n } = useTranslation('common');

    React.useEffect(() => {
        setTwitter(props.twitter || '');
        setInstagram(props.instagram || '');
        setLinkedin(props.linkedin || '');
    }, [props.twitter, props.instagram, props.linkedin]);

    return (
        <>
            <Container onClick={() => setPopupOpen(true)}>
                <div>
                    {twitter && <img src='/img/twitter.png' alt="twitter"/>}
                    {instagram && <img src='/img/instagram.png' alt="instagram"/>}
                    {linkedin && <img src='/img/linkedin.png' alt="linkedin"/>}
                    {(!twitter && !instagram && !linkedin) && <span>{i18n.language === "fr" ? "Réseaux sociaux" : "Social networks"}</span>}
                </div>
                <img className="croix_bleue" src='/img/croix_bleue.png' alt='fermer' />
            </Container>
            {popupOpen && <Popup close={() => setPopupOpen(false)}>
                <H2>{i18n.language === "fr" ? "Réseaux sociaux" : "Social networks"}</H2><br/>
                <Input style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Identifiant Twitter" : "Twitter handle"} defaultValue={twitter} onChange={(event) => setTwitter(event.target.value)} /><br/><br/>
                <Input style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Identifiant Instagram" : "Instagram handle"} defaultValue={instagram} onChange={(event) => setInstagram(event.target.value)} /><br/><br/>
                <Input style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Lien LinkedIn" : "LinkedIn link"} defaultValue={linkedin} onChange={(event) => setLinkedin(event.target.value)} /><br/><br/>
                <BlueButton onClick={() => setPopupOpen(false)}>{i18n.language === "fr" ? "Valider" : "Validate"}</BlueButton>
            </Popup>}
            <input hidden readOnly name="twitter" value={twitter} />
            <input hidden readOnly name="instagram" value={instagram} />
            <input hidden readOnly name="linkedin" value={linkedin} />
        </>
    );
}

export default SocialNetworks;